module.exports = __webpack_public_path__ + "img/licaimofan.bd608bf1.png";